module.exports = __webpack_public_path__ + "img/default-upload-img.png";